import {
	fullStateUpdated,
	popInSessionEnded,
	popInSessionEventCreated,
	popInSessionEventUpdated,
	popInSessionStarted,
	popInSessionUpdated,
	popInSessionUserJoined,
	popInSessionUserLeft,
} from "./store/actions";
import { Store } from "./store";
import {
	PopInSessionEvent,
	PopInSessionPayload,
	PopInSessionUpdate,
	PopInSessionUserSession,
} from "./store/slices/popInSessions";

export type PopInSessionMessage =
	| {
			type: "fullState";
			payload: Record<string, PopInSessionPayload>;
	  }
	| { type: "liveSessionStarted"; payload: PopInSessionPayload }
	| { type: "liveSessionUpdated"; payload: PopInSessionUpdate }
	| { type: "liveSessionEnded"; payload: string }
	| { type: "userSessionCreated"; payload: PopInSessionUserSession }
	| { type: "userSessionDeleted"; payload: PopInSessionUserSession }
	| { type: "liveSessionEventCreated"; payload: PopInSessionEvent }
	| {
			type: "liveSessionEventUpdated";
			payload: PopInSessionEvent;
	  };

export default function handlePopInSessionMessage({ dispatch }: Store, { type, payload }: PopInSessionMessage) {
	switch (type) {
		case "liveSessionStarted":
			dispatch(popInSessionStarted(payload));
			break;
		case "liveSessionUpdated":
			dispatch(popInSessionUpdated(payload));
			break;
		case "liveSessionEnded":
			dispatch(popInSessionEnded(payload));
			break;
		case "userSessionCreated":
			dispatch(popInSessionUserJoined(payload));
			break;
		case "userSessionDeleted":
			dispatch(popInSessionUserLeft(payload));
			break;
		case "liveSessionEventCreated":
			dispatch(popInSessionEventCreated(payload));
			break;
		case "liveSessionEventUpdated":
			dispatch(popInSessionEventUpdated(payload));
			break;
		case "fullState":
			dispatch(fullStateUpdated(payload));
			break;
		default:
			console.error("Unknown pop in message type", type);
	}
}
